import { Routes } from "@angular/router";
import { authGuard } from "./core/guards/auth.guard";
import { AdminLayoutComponent } from "./core/layouts/admin-layout/admin-layout.component";

export const routes: Routes = [
  {
    path: "login",
    loadComponent: () =>
      import("./features/auth/pages/login/login.component").then((m) => m.LoginComponent)
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard"
      },
      {
        path: "dashboard",
        loadComponent: () =>
          import("./features/dashboard/pages/dashboard.component").then((m) => m.DashboardComponent)
      },
      {
        path: "cash",
        loadComponent: () => import("./features/cash/pages/cash.component").then((m) => m.CashComponent)
      },
      {
        path: "movements",
        loadComponent: () =>
          import("./features/movements/pages/movements.component").then((m) => m.MovementsComponent)
      },
      {
        path: "categories",
        loadComponent: () =>
          import("./features/categories/pages/categories.component").then((m) => m.CategoriesComponent)
      },
      {
        path: "reports",
        loadComponent: () => import("./features/reports/pages/reports.component").then((m) => m.ReportsComponent)
      },
      {
        path: "audit",
        loadComponent: () => import("./features/audit/pages/audit.component").then((m) => m.AuditComponent)
      },
      {
        path: "users",
        loadComponent: () => import("./features/users/pages/users.component").then((m) => m.UsersComponent)
      },
      {
        path: "permissions",
        loadComponent: () =>
          import("./features/permissions/pages/permissions.component").then((m) => m.PermissionsComponent)
      },
      {
        path: "income-requests",
        loadComponent: () =>
          import("./features/income-requests/pages/income-requests.component").then((m) => m.IncomeRequestsComponent)
      },
      {
        path: "workers",
        loadComponent: () =>
          import("./features/workers/pages/workers.component").then((m) => m.WorkersComponent)
      }
    ]
  },
  {
    path: "**",
    redirectTo: ""
  }
];
